export interface Subject {
  id: number
  name: string
  minSLUsersNumber: number
  minHLUsersNumber: number
  indexes: Index[]
  selectionsNumber: number
  qualification: string | null
  isOnlySL: boolean
  isOnlyHL: boolean
}

export interface Index {
  id?: number
  subjectId: number
  index: number
  requirements: IndexRequirement[]
}

export enum IndexRequirementType {
  REQUIRE = 'REQUIRE',
  BLOCK = 'BLOCK',
  // REQUIRED = "REQUIRED"
}

export interface Requirement {
  type?: IndexRequirementType
  index?: number
  subjectId?: number
}

export interface IndexRequirement {
  id?: number
  indexId: number
  requirement: Requirement
}
